<template lang="pug">
  sui-segment(vertical)
    sui-grid
      slot(name="header")
        sui-grid-row
          sui-grid-column
            sui-header(
              textAlign="center",
              :size="headerSize") {{ map }}

      sui-grid-row(verticalAlign="middle")
        sui-grid-column(:width="6")
          sui-image(
            centered,
            :size="imageSize",
            :src="awayTeam ? awayTeam.logo.main.svg : defaults.logo")

        sui-grid-column(
          :width="2",
          v-for="score, i in displayedScores",
          :key="i")
          sui-header(
            :size="headerSize",
            textAlign="center") {{ score }}

        sui-grid-column(:width="6")
          sui-image(
            centered,
            :size="imageSize",
            :src="homeTeam ? homeTeam.logo.main.svg : defaults.logo")
</template>

<script>
export default {
  name: 'GameScore',
  props: {
    scores: {
      required: true,
    },
    teams: {
      required: true,
    },
    map: {
      required: true,
    },
    headerSize: {
      default: 'large',
    },
    imageSize: {
      default: 'tiny',
    },
  },
  data() {
    return {
      defaults: {
        name: '--',
        logo: '/logo-placeholder.svg',
      },
    };
  },
  computed: {
    displayedScores() {
      return this.scores || [0, 0];
    },
    awayTeam() {
      return this.teams[0];
    },
    homeTeam() {
      return this.teams[1];
    },
  },
};
</script>

